<router-outlet></router-outlet>
<div class="front-cookie-popup"></div>
<div class="front-cookie-popup-details"></div>
